// Save the original bytes through a same-origin blob URL. Navigating to an
// inline S3 URL can invoke Edge's Office viewer even with an <a download>.
export async function downloadPreviewFile(fileUrl: string, filename: string, signal: AbortSignal) {
  const response = await fetch(fileUrl, { signal });
  if (!response.ok) throw new Error(`Download failed (${response.status})`);
  const blob = await response.blob();
  if (signal.aborted) return;

  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.append(anchor);
  try {
    anchor.click();
  } finally {
    anchor.remove();
    // Give the browser time to start consuming the URL before releasing it.
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  }
}
